import styled from "style/themed";

export const ToolsTitle = styled.h3`
  margin: ${({ theme }) => theme.margin.medium} 0;
`;
